/* 
ALL RIGHTS RESERVED. The content of this document is protected by copyright and constitutes trade secrets.  
The content hereof may also be protected by patents, trademarks, design rights and other intellectual property rights. 
The rights contained herein are owned or licensed by Temperature Sensitive Solutions Systems Sweden AB,  
reg. no. 556278-0816, Sweden, ("TSS"), and may not be used, licensed, assigned, transferred, reproduced, copied,  
disclosed, disseminated, modified or amended in any way not expressly and specifically granted by TSS in writing. 
TSS and TSS' suppliers reserves any and all rights not expressly granted to you in writing, including the right to take  
any and all actions deemed appropriate to safeguard its rights in and to the content of this document. 
*/
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

import {
  historyShape,
  locationShape,
} from 'tss-core-lib-common';
import { Loading, FadeOut, WithFilter } from 'tss-core-lib-components';

import ContactInfoListPage from '../pages/ContactInfoListPage';
import numbers from '../data/country_specific_numbers';

const LIMIT = 10;


class ContactInfoListContainer extends Component {
  static contextTypes = {};

  static propTypes = {
    history: historyShape.isRequired,
    location: locationShape.isRequired,
  };

  static defaultProps = {};

  constructor() {
    super();
    const sortedNumbers = numbers.sort( ( a, b ) => ( ( a.country > b.country ) ? 1 : -1 ) );
    this.state = { numbers: sortedNumbers, numberTotalCount: sortedNumbers.length };
  }

  state = { dataInitialized: false };

  search = async ( query ) => this.state.numbers.filter( ( item ) =>
    item.country.toLowerCase().search( query.toLowerCase() ) !== -1,
  );
  fetchUsers = async ( props, options ) => {
    const offset = Reflect.has( options, 'pageNr' )
      ? ( options.pageNr - 1 ) * LIMIT
      : 0;
    try {
      const state = { };
      if ( options.searchQuery && options.searchQuery.length > 1 ) {
        const updatedList = await this.search( options.searchQuery, this.state.numbers );
        state.dataInitialized = true;
        state.numberTotalCount = updatedList.length;
        if ( updatedList.length > LIMIT ) {
          state.contacts = updatedList.slice( updatedList.length < offset, offset + LIMIT );
        } else {
          state.contacts = updatedList;
        }
      } else {
        state.dataInitialized = true;
        state.numberTotalCount = this.state.numbers.length;
        state.contacts = this.state.numbers.slice( offset, offset + LIMIT );
      }
      this.setState( state );
    } catch ( e ) {
      if ( e.response && e.response.status === 412 ) {
        this.setState( {
          error: true,
          errorMessageCode: e.data ? e.data.message : 'unknown.error',
        } );
      }
    }
  };

  render() {
    return (
      <WithFilter
        history={ this.props.history }
        location={ this.props.location }
        // defaultSortBy={ 'SORT_BY.EMAIL' }
        defaultSortDesc={ false }
        postProcessOptions={ this.postProcessOptions }
        fetcher={ this.fetchUsers }
        render={ ( options, callbacks ) => {
          if ( !this.state.dataInitialized ) {
            return <FadeOut><Loading fill /></FadeOut>;
          }
          return (
            <ContactInfoListPage
              contacts={ this.state.contacts }
              searchQuery={ options.searchQuery || '' }
              pageNr={ options.pageNr || 1 }
              totalPages={ Math.ceil( this.state.numberTotalCount / LIMIT ) || 1 }
              { ...callbacks }
            />
          );
        } }
      />
    );
  }
}

export default ( injectIntl( ContactInfoListContainer ) );



// WEBPACK FOOTER //
// ./src/containers/ContactInfoListContainer.js